import type React from 'react';
import ReactHighlighter from 'react-highlight-words';

type HighlighterProps =
    | {
          highlight?: string;
          highlightAllWhenMatching?: never;
          children?:
              | string
              | number
              | null
              | (string | number | undefined | null)[];
      }
    | {
          highlight?: string;
          highlightAllWhenMatching?: string | number;
          children?: React.ReactNode;
      };

export const Highlighter = ({
    highlight,
    highlightAllWhenMatching,
    children,
}: HighlighterProps) => {
    if (!highlight) return <>{children}</>;

    if (highlightAllWhenMatching) {
        if (
            highlight.split(' ').includes(highlightAllWhenMatching.toString())
        ) {
            return <mark className="bg-branded p-0">{children}</mark>;
        } else {
            return <>{children}</>;
        }
    }

    const textToHighlight =
        children instanceof Array
            ? children.join('')
            : (children?.toString() ?? '');
    return (
        <ReactHighlighter
            highlightClassName="bg-branded p-0"
            autoEscape
            searchWords={highlight.split(' ')}
            textToHighlight={textToHighlight}
        />
    );
};
